export enum EGradientDirection {
    TopToBottom = "to bottom",
    BottomToTop = "to top",
    LeftToRight = "to right",
    RightToLeft = "to left",
    TopLeftToBottomRight = "to bottom right",
    BottomRightToTopLeft = "to top left",
    TopRightToBottomLeft = "to bottom left",
    BottomLeftToTopRight = "to top right",
}

export enum EFontWeights {
    Normal = "normal",
    Bold = "bold",
    Bolder = "bolder",
}

export enum EBundleDesign {
    AK = "ak",
    MATCH = "match",
    MAIN_SUB = "mainSub",
}

export enum EProductType {
    TIME = "Time",
    QUANTITY = "Quantity",
}

export enum EProductPriority {
    MAIN = "Main",
    SUB = "Sub",
}

export enum EBadgePosition {
    LEFT = "left",
    RIGHT = "right",
    TOP = "top",
    BOTTOM = "bottom",
    CENTER = "center"
}

export enum EBadgeType {
    EMBLEM = "emblem",
    RIBBON = "ribbon"
}

export enum EPaymentMethod {
    CARD = "card",
    APPLE = "apple",
    GOOGLE = "google",
    PAYPAL = "paypal",
    E_WALLET = "e-wallet"
}